import React, { useEffect, useState } from "react";
import { Form, Input, Button, Row, Col, message } from "antd";
import {post} from '../services/HttpService'
import styled from "styled-components";
import useAuth from "../hooks/useAuth";
const PageOuter = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const LoginForm = styled(Form)`
  border: 1px solid #eee;
  padding: 20px;
  width: 450px;
  border-radius: 6px;
`;
const AdminLogin = ({ history }) => {
  const { toLogin } = useAuth();
  const [captchaId, setCaptchaId] = useState("");
  const [captchaImg, setCaptchaImg] = useState("");
  const [form] = Form.useForm();
  const getRequiredMesage = (msg) => {
    return [
      {
        required: true,
        message: msg,
      },
    ];
  };
  const loadCaptcha = async () => {
    let res = await post('/auth/captcha');
    if (res.ok) {
      setCaptchaId(res.payload.captchaId);
      setCaptchaImg(res.payload.img);
    }
  };
  useEffect(() => {
    loadCaptcha();
    return () => {};
  }, []);
  const onFinished = async (value) => {
    let res = await post('/auth/adminlogin', { ...value, captchaId });
    if (res.ok) {
      let token = res.payload.token;
      toLogin(token);
      history.replace("/admin/home");
    } else {
      message.error("用户名、密码或验证码错误");
      form.setFieldsValue({ captcha: "" });
      await loadCaptcha();
    }
  };
  return (
    <PageOuter>
      <LoginForm
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 24 }}
        onFinish={onFinished}
      >
        <Form.Item
          label="用户名"
          name="uname"
          rules={getRequiredMesage("请填写用户名")}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="登录密码"
          name="pass"
          rules={getRequiredMesage("请填写登录密码")}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          label="验证码"
          name="captcha"
          rules={getRequiredMesage("请填写验证码")}
        >
          <Row gutter={8}>
            <Col span={14}>
              <Input autoComplete="off" />
            </Col>
            <Col span={10}>
              {captchaImg ? (
                <img
                  src={captchaImg}
                  alt="验证码"
                  onClick={loadCaptcha}
                  style={{ height: 32, cursor: "pointer", width: "100%" }}
                />
              ) : null}
            </Col>
          </Row>
        </Form.Item>
        <Form.Item style={{ textAlign: "center", marginBottom: 0 }}>
          <Button type="primary" htmlType="submit">
            登录
          </Button>
        </Form.Item>
      </LoginForm>
    </PageOuter>
  );
};

export default AdminLogin;
